import gql from 'graphql-tag';

export default gql`
  mutation shopeeUpdataTrackingManual($order_id: String!) {
    shopeeUpdataTrackingManual(order_id: $order_id) {
      succeed
    }
  }
`;
